import { render, staticRenderFns } from "./double-bounce-spinner.vue?vue&type=template&id=53da6d8f"
import script from "./double-bounce-spinner.vue?vue&type=script&lang=js"
export * from "./double-bounce-spinner.vue?vue&type=script&lang=js"
import style0 from "./double-bounce-spinner.vue?vue&type=style&index=0&id=53da6d8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports